import { FunctionComponent } from 'react';

import AlternatingText from 'components/AlternatingText';
import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useCancelled from './useCancelled';

const Cancelled: FunctionComponent = () => {
  const { subtitleArray, line2, isLoading } = useCancelled();

  return (
    <PleaseWaitOverlay
      icon="error"
      iconClassName="text-red-200 mb-4"
      title="This loan has been canceled"
      labelLine1={<AlternatingText array={subtitleArray} />}
      labelLine2={line2}
      isLoading={isLoading}
    />
  );
};

export default Cancelled;
